export const RUN_TYPE = {
  INTERVAL: 1,
  FIXED: 2
};

export const INTERVAL_UNIT = {
  MINUTE: 1,
  HOUR: 2
};
